export default __webpack_public_path__ + "static/media/T860MANB1.97903dc7.pdf";